import React from 'react'
import { Wrapper } from './imgabovefooter.style'

const ImgAboveFooter = ({bgImg}) => {
  return (
    <Wrapper>
        <div className="aboveFooter">
            <img src={bgImg} alt="" />
        </div>
    </Wrapper>
  )
}

export default ImgAboveFooter